import { attachPublishedSourceData } from "./attach-published-source-data"
import { getDraftOrPublishedSchedules } from "../controller/get-draft-or-published-schedules"
import { isSendToLegacyBlockingSchedule } from "./is-send-to-legacy-blocking-schedule"
import { isAlreadyPublishedNewSchedule } from "authoring/lib/enum/new-schedule-creation-type.mjs"

export async function getLegacyScheduleSplit({ projectId, scheduleIds }) {
    try {
        const schedules = await getDraftOrPublishedSchedules({ projectId, scheduleIds })
        const resolvedSchedules = Array.isArray(schedules) ? schedules : []
        const approved = resolvedSchedules.filter(isEligibleForLegacySend)
        const alreadyPublished = resolvedSchedules.filter(isAlreadyPublishedNewSchedule)
        const blocking = resolvedSchedules.filter(isSendToLegacyBlockingSchedule)
        return {
            approved: await attachPublishedSourceData({ projectId, schedules: approved }),
            blocking,
            alreadyPublished,
        }
    } catch (error) {
        console.error(error)
        return null
    }
}

export function isEligibleForLegacySend(schedule) {
    return !isSendToLegacyBlockingSchedule(schedule) && !isAlreadyPublishedNewSchedule(schedule)
}
